import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import config from "../../../../config/config";
import axios from "axios";

const EmergencyContactComponent = () => {
  const { workerUser } = useOutletContext();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [relationship, setRelationship] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    if (
      workerUser &&
      workerUser.emergencyContacts &&
      workerUser.emergencyContacts.length > 0
    ) {
      const contact = workerUser.emergencyContacts[0];
      setFirstName(contact.firstName || "");
      setLastName(contact.lastName || "");
      setContactNumber(contact.phoneNumber || "");
      setRelationship(contact.relationship || "");
    }
  }, [workerUser]);

  const handleSaveChanges = async () => {
    const emergencyContact = {
      firstName,
      lastName,
      phoneNumber: contactNumber,
      relationship,
    };

    try {
      const updateUserResponse = await axios.patch(
        `${baseURL}/v1/worker-users/${workerUser.id}`,
        {
          emergencyContacts: [emergencyContact],
        }
      );

      if (updateUserResponse.data) {
        console.log("Patch successful");
        setSuccessMessage("Emergency contact saved successfully!");
      } else {
        console.log("Patch succeeded but no data returned");
      }
    } catch (error) {
      console.error("Failed to patch user data:", error);
    }
  };

  const handleClose = () => {
    setSuccessMessage("");
  };

  return (
    <div className="emergency-contact-settings-container">
      {successMessage && (
        <div className="claim-success-message">
          <FaCheckCircle className="invoice-check-icon" />
          <h4>{successMessage}</h4>
          <IoMdClose className="success-message-close" onClick={handleClose} />
        </div>
      )}
      <div className="emergency-account-settings">
        <h3>Emergency Contact Information</h3>
        <label htmlFor="firstName">First Name</label>
        <input
          type="text"
          id="firstName"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <label htmlFor="lastName">Last Name</label>
        <input
          type="text"
          id="lastName"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <label htmlFor="contactNumber">Phone Number</label>
        <input
          type="tel"
          id="contactNumber"
          value={contactNumber}
          onChange={(e) => setContactNumber(e.target.value)}
        />
        <label htmlFor="relationship">Relationship</label>
        <select
          id="relationship"
          value={relationship}
          onChange={(e) => setRelationship(e.target.value)}
        >
          <option value="Partner / Spouse">Partner / Spouse</option>
          <option value="Immediate Family">Immediate Family</option>
          <option value="Extended Family">Extended Family</option>
          <option value="Legal Representative / Advocate">
            Legal Representative / Advocate
          </option>
          <option value="Approved Provider / Care Coordinator">
            Approved Provider / Care Coordinator
          </option>
          <option value="Friend / Neighbour">Friend / Neighbour</option>
        </select>
        <button className="emergency-save-button" onClick={handleSaveChanges}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default EmergencyContactComponent;
